import {TemplateList} from "~/libs/constants/TemplateList"

export const useUniWebTemplate = () => {
  type TemplateListKeys = keyof typeof TemplateList;
  const uniWebTemplateNameLowerCase:TemplateList | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toLowerCase() as TemplateList : undefined
  const uniWebTemplateNameUpperCase:TemplateListKeys | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toUpperCase() as TemplateListKeys : undefined

  const getComponentPathPrefix = (): string | undefined => {
    if (uniWebTemplateNameLowerCase) {
      return uniWebTemplateNameLowerCase.charAt(0).toUpperCase()
        + uniWebTemplateNameLowerCase.slice(1)
    }
  }

  const getTemplateListItem = (): TemplateList | undefined => {
    if (uniWebTemplateNameUpperCase && TemplateList[uniWebTemplateNameUpperCase]) {
      return TemplateList[uniWebTemplateNameUpperCase]
    }
  }

  return {
    uniWebTemplateNameLowerCase,
    uniWebTemplateNameUpperCase,
    getComponentPathPrefix,
    getTemplateListItem
  }

}
